import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { CustomDropdown } from '../deps.js';
import AdminModal from '../AdminModal.js';
import AdminBulkPreview from '../AdminBulkPreview.js';

const BulkAddToTeamModal = ({ isOpen, onClose, onConfirm, users, teams, loading }) => {
  const [selectedTeam, setSelectedTeam] = useState('');
  const [teamDropdownOpen, setTeamDropdownOpen] = useState(false);
  const teamDropdownRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      setSelectedTeam('');
      setTeamDropdownOpen(false);
    }
  }, [isOpen]);

  const handleConfirm = () => {
    if (selectedTeam) {
      onConfirm(selectedTeam);
    }
  };

  return (
    <AdminModal
      isOpen={isOpen && users?.length > 0}
      onClose={onClose}
      title="Add Users to Team"
      actions={(
        <>
          <button className="cancel-button" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button
            className="admin-submit-button"
            onClick={handleConfirm}
            disabled={loading || !selectedTeam}
          >
            {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Add to Team'}
          </button>
        </>
      )}
    >
      <p>Add {users?.length} user{users?.length > 1 ? 's' : ''} to team:</p>
      <div className="admin-form-group">
        <label>Select Team:</label>
        <CustomDropdown
          selected={selectedTeam ? (teams.find((t) => t.teamId === selectedTeam)?.teamName || selectedTeam) : 'Select Team'}
          options={
            teams
              .map((team) => ({
                id: team.teamId,
                display: team.teamName,
                value: team.teamId,
              }))
              .sort((a, b) => a.display.localeCompare(b.display))
          }
          isOpen={teamDropdownOpen}
          toggleDropdown={() => setTeamDropdownOpen(!teamDropdownOpen)}
          onSelect={(option) => {
            setSelectedTeam(option.value);
            setTeamDropdownOpen(false);
          }}
          className="admin-role-select"
          containerRef={teamDropdownRef}
          keyExtractor={(option) => option.id}
        />
      </div>
      <AdminBulkPreview
        items={users || []}
        getKey={(user) => user.userId}
        getName={(user) => user.name}
        getMeta={(user) => user.email}
        noun="user"
      />
    </AdminModal>
  );
};

export default BulkAddToTeamModal;
